/**
 * Tag — small pill label, used for service cards metadata.
 */
export default function Tag({ className = '', children }) {
  return (
    <span
      className={
        'inline-flex items-center font-mono text-mono-xs tracking-[0.05em] ' +
        'px-2.5 py-1 rounded-full bg-white/[.04] border border-white/[.08] text-ink-200 ' +
        className
      }
    >
      {children}
    </span>
  );
}
